/**
 * These are an easy, convenient unique string for HTML element id's
 */
const generateGuid = (): string => {
  const S4 = () =>
    // eslint-disable-next-line implicit-arrow-linebreak,no-bitwise
    ((1 + Math.random()) * 0x10000 | 0).toString(16)
      .substring(1);
  return `${S4() + S4()}-${S4()}-${S4()}-${S4()}-${S4()}${S4()}${S4()}`;
};

export default generateGuid;
